import { reactive, ref, type Reactive, type Ref } from 'vue';
import { initMoviePlayerState } from 'src/lib/moviePlayerHelper';
import {
  useMoviePlayerCommonRefs,
  type MoviePlayerCommonRefsContext,
} from 'src/components/lib/MoviePlayer/composables/useMoviePlayerCommonRefs';
import type { IMoviePlayerVideo } from 'src/models';
import type { MoviePlayerState } from 'src/models/moviePlayer';

type BasicPlayerStateContext = MoviePlayerCommonRefsContext & {
  state: Reactive<MoviePlayerState>;
  refMoviePlayerVideos: Ref<IMoviePlayerVideo[] | undefined>;
};

// BasicMoviePlayerのstate・refs・非同期マスタ取得のみを提供する。
// 他のcomposableは構築せず、BasicMoviePlayer/index.vue側でDI順に直接構築する。
export function useBasicPlayerState(): BasicPlayerStateContext {
  const state = reactive<MoviePlayerState>(initMoviePlayerState());
  const refMoviePlayerVideos = ref<IMoviePlayerVideo[]>();

  return {
    state,
    refMoviePlayerVideos,
    ...useMoviePlayerCommonRefs(),
  };
}
